import React from 'react';
import { BoolToString, SortedRegTypeOrder } from 'components';
import _ from 'lodash';
import { getTableColumns } from 'helpers';

const OpenInvesColumns = [
  ...getTableColumns(
    [
      ['id', 'string', 'OPEN Person Type', 'left', true]
    ]
  ),
  {
    name: 'isMandatory',
    type: 'string',
    label: 'Required',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isMandatory} />)
  },
  {
    name: 'isMultiple',
    type: 'string',
    label: 'Multiple',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isMultiple} />)

  },
  {
    name: 'value',
    type: 'string',
    label: 'Registration Types',
    filterable: true,
    renderCell: data => {
      const sortedArr = SortedRegTypeOrder(_.uniq(data.value));
      return (
        <div>
          {sortedArr && sortedArr.join(', ')}
        </div>
      );
    }
  }
];

export default OpenInvesColumns;
